import { Brand } from "@/models/Brands.model";
import { AspectRatio, Box, Grid, Heading, Text } from "@radix-ui/themes";
import { FC, JSX } from "react";

const BrandSingleUI: FC<Brand> = ({ name, logoURL, about }): JSX.Element => {
  return (
    <Grid columns={{ initial: "4", lg: "12" }} gap="3">
      <Box gridColumn={{ initial: "1 / 2", lg: "1 / 2" }}>
        <AspectRatio ratio={1 / 1}>
          <img
            src={logoURL}
            alt={`${name} logo`}
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              borderRadius: "var(--radius-2)",
            }}
          />
        </AspectRatio>
      </Box>
      <Box gridColumn={{ initial: "2 / 5", lg: "2 / 13" }}>
        <Heading as="h3" size="4" mb="1">
          {name}
        </Heading>
        <Text as="p" size="2" color="gray">
          {about}
        </Text>
      </Box>
    </Grid>
  );
};

export default BrandSingleUI;
